import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { BsCardList, BsTable } from "react-icons/bs";

export default function ToggleCardTable({ viewMode, setViewMode }) {
  return (
    <ButtonGroup>
      <ToggleButton
        id="toggle-card"
        type="radio"
        variant={viewMode === "card" ? "primary" : "outline-primary"}
        name="viewMode"
        value="card"
        title="Vista Tarjetas"
        checked={viewMode === "card"}
        onChange={(e) => setViewMode(e.currentTarget.value)}
      >
        <BsCardList />
      </ToggleButton>
      <ToggleButton
        id="toggle-table"
        type="radio"
        variant={viewMode === "table" ? "primary" : "outline-primary"}
        name="viewMode"
        value="table"
        title="Vista Tabla"
        checked={viewMode === "table"}
        onChange={(e) => setViewMode(e.currentTarget.value)}
      >
        <BsTable />
      </ToggleButton>
    </ButtonGroup>
  );
}
